import type { ComponentProps } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { Select } from '@/components/common/select';

import { FormField } from '../form-field';

type SelectBaseProps = Omit<ComponentProps<typeof Select>, 'value' | 'onChange' | 'mode'>;

export type MultiSelectFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = SelectBaseProps & {
  name: TName;
  control: Control<TFieldValues>;
  label?: string;
  help?: string;
  required?: boolean;
};

export function MultiSelectField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  help,
  required,
  allowClear = true,
  ...rest
}: MultiSelectFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} label={label} help={help} required={required}>
      {({ field, fieldState }) => (
        <Select
          {...rest}
          id={name}
          mode="multiple"
          allowClear={allowClear}
          style={{ width: '100%', ...rest.style }}
          status={fieldState.error ? 'error' : undefined}
          value={field.value ?? []}
          onChange={field.onChange}
          onBlur={field.onBlur}
          ref={field.ref}
        />
      )}
    </FormField>
  );
}
